import {Observable} from 'rxjs';

/**
 * @deprecated disabled controller
 */
export interface INickCalculateController {
    fieldAccessor(id: string[], defaultValue: any, includeVirtual?: boolean): Observable<any>;
}
